export default __webpack_public_path__ + "static/media/homeArtwork.58809f84.png";